var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15799_6433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2987 5.70973C17.9087 5.31973 17.2787 5.31973 16.8887 5.70973L11.9988 10.5897L7.10875 5.69973C6.71875 5.30973 6.08875 5.30973 5.69875 5.69973C5.30875 6.08973 5.30875 6.71973 5.69875 7.10973L10.5888 11.9997L5.69875 16.8897C5.30875 17.2797 5.30875 17.9097 5.69875 18.2997C6.08875 18.6897 6.71875 18.6897 7.10875 18.2997L11.9988 13.4097L16.8887 18.2997C17.2787 18.6897 17.9087 18.6897 18.2987 18.2997C18.6887 17.9097 18.6887 17.2797 18.2987 16.8897L13.4087 11.9997L18.2987 7.10973C18.6787 6.72973 18.6787 6.08973 18.2987 5.70973Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15799_6433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.4327ea2ee223ee1daacb86e6387a41cf.svg";
export { ForwardRef as ReactComponent };